import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: media.Image.
export default class Image extends Fragment {
  declare [Type]: 'media/image';
}
